import api from '../../plugins/api';

const getDealServices = (params) => {
  return api.get('/api/crm/deals/getDealServices', params);
};

export default getDealServices;
